import { Component, Input, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'card-context-menu',
  template: require('./board.card-context-menu.component.html'),
})
export class CardContextMenuComponent {
  @Input() boardOptions: any;
  @Input() card: any;
  @Input() onMenuClick: any;

  constructor(private stateService: StateService) {
  }

  onMenuItemClickCol(event: any, card: any, col: any) {
    event.stopPropagation();
    event.preventDefault();

    if (typeof this.onMenuClick === 'function') {
      let params: any = {card: card, col: col};
      this.onMenuClick(params);
    }
  }

  onMenuItemClickRow(event: any, card: any, row: any) {
    event.stopPropagation();
    event.preventDefault();

    if (typeof this.onMenuClick === 'function') {
      let params: any = {card: card, row: row};
      this.onMenuClick(params);
    }
  }
}
